import { Product } from './product';
import { OrderLineType } from './order-line-type';
import { JSONUtilites } from '../../../helpers/JSONUtilites';

export class ProductGroup {
  constructor(
    public groupType: OrderLineType,
    public products: Product[],
  ) {
  }

  static createFromAny(data: any): ProductGroup {
    if (data === null || data === undefined) {
      return null;
    }

    return new ProductGroup(
      OrderLineType[data.groupType + ''],
      data.products ? data.products.map(product => Product.createFromAny(product)) : [],
    );
  }
}
